module.exports = __webpack_public_path__ + "img/kemonap.7509546c.jpg";